const highlightBg = (state = false, action)=>{
    if(action.type === "SET_BG_HIGHLIGHT"){
        state = action.state
    }
    return state;
}

export default highlightBg;